// Topbar.jsx

import React, { useEffect, useState } from 'react';
import '../styles/Topbar.scss';
import Logo from "../images/PHOENIXSOLUTION-1.png"

const Topbar = () => {
  return (
    <section className="topbar">
      <header>
        <nav>
          <a href=""><img src={Logo} alt="Logo" /></a>
          <a href="">PHOENIX SOLUTION</a>
          {/* <a href="">HOME</a> */}
          {/* <a href="">Silicon wafers</a>
          <a href="">Semiconductor materials</a>
          <a href="">Semiconductor machineries</a>
          <a href="">3D visualisation and games</a>
          <a href="">Electronic embedded system</a>
          <a href="">Radar system</a>
          <a href="">Sonar system</a>
          <a href="">Radar and sonar software</a>
          <a href="">VFX</a>
          <a href="">Targeting and navigation system</a>
          <a href="">Simulation software</a> */}
        </nav>
      </header>
    </section>
  );
};

export default Topbar;